import { Autocomplete, SxProps, TextField } from "@mui/material";
import { useEffect, useState } from "react";
import { CityEscapeData } from "../types/cityEscape";

export function CityEscapesDropdown({
  id,
  cityEscapes,
  selectedId,
  onChange,
  sx,
}: {
  id?: string;
  cityEscapes: CityEscapeData[];
  selectedId?: string;
  onChange?: (value: CityEscapeData | null) => void;
  sx?: SxProps;
}) {
  // const [value, setValue] = useState<CityEscapeData | null>(null);

  // useEffect(() => {
  //   setValue( || null);
  // }, []);

  return (
    <Autocomplete
      id={id}
      disablePortal
      options={cityEscapes}
      sx={sx}
      onBlur={(event) => {
        event.stopPropagation();
        event.preventDefault();
      }}
      value={cityEscapes.find((ce) => ce.id === selectedId)}
      renderInput={(params) => <TextField {...params} label="City Escape" />}
      onChange={(event, newValue) => {
        console.debug("City escape selected from dropdown:", newValue);
        // setValue(newValue);
        onChange?.(newValue);
      }}
    />
  );
}
